import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaBroom, FaChartBar, FaMailBulk, FaPaperPlane, FaUser } from 'react-icons/fa';
import { useLoading } from '../../../../../../hooks/LoadingHook';
import { useModal } from '../../../../../../hooks/Modal';




interface ICreateModule {
  lineData: Record<string, any>;
}

const removerAcentos = (value: string): string => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  const acentos: { [key: string]: string } = {
    'ÍÌĨÏÎ': 'I',
    'ÁÀÃÄÂ': 'A',
    'ÉÈẼËÊ': 'E',
    'ÓÒÕÖÔ': 'O',
    'ÚÙŨÜÛ': 'U',
    'Ç': 'C',
    "'`": '' // Remove apóstrofos e acentos graves
  };

  value = value.toUpperCase();

  for (const pattern in acentos) {
    const regex = new RegExp(`[${pattern}]`, 'g');
    value = value.replace(regex, acentos[pattern]);
  }

  return value;
}


export default function ContactModule(): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();

  const ChangeUser = async () => {

    const content = await api.get('invitation-confirmation', { params: { limitItems: 100000 } });


    let x = 0;

    while (x < content?.data?.rows?.length) {

      const item = content?.data?.rows[x];

      await api.put(`/invitation-confirmation/${item?._id?.toString()}/clean_name`, { clean_name: `${removerAcentos(item?.name)}${removerAcentos(item?.changed_by || '')}` })
      addToast({ title: `${x + 1}/${content?.data?.rows?.length} - ${item?.name}` })
      x += 1;
    }



  }

  const sendMailCheck = () => {

    addModal({
      title: '', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '#333', width: '100%', textAlign: 'center' }}>Confirmar limpeza?</h2>
        <button className='greenButton2' style={{ margin: '10px auto' }} type='button' onClick={() => { ChangeUser() }}>Sim</button>

      </>
    })

  }



  const moduleUpdate = (): JSX.Element => (
    <button className='searchButton' title='Limpar nomes' onClick={() => { sendMailCheck() }}><FaBroom /></button>
  );

  return moduleUpdate();
}
